export default __webpack_public_path__ + "static/media/ic_components.af1e1618.svg";